// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PauseCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/PauseCircleTwoTone";
import AntdIcon from '../components/AntdIcon';

var PauseCircleTwoTone = function PauseCircleTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PauseCircleTwoToneSvg
  }));
};

PauseCircleTwoTone.displayName = 'PauseCircleTwoTone';
export default React.forwardRef(PauseCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/PauseCircleTwoTone.js
// module id = 1543
// module chunks = 0